import { useEffect } from 'react'
import { initClarity } from '../utils/clarity'

// Bootstraps Microsoft Clarity on mount for the Laiten landing routes. Renders nothing.
const ClarityInit = () => {
  useEffect(() => {
    initClarity()
  }, [])
  return null
}

export default ClarityInit
